export enum RumConfig {
GUEST_ROLE_ARN =
    'arn:aws:iam::508961012545:role/RUM-Monitor-eu-north-1-508961012545-6835735985961-Unauth',
IDENTITY_POOL_ID = 'eu-north-1:0513a630-aeda-4244-aa14-52a6d4d6ea75',
END_POINT ='https://dataplane.rum.eu-north-1.amazonaws.com',
APPLICATION_ID = 'c22cb0d1-85fb-445d-8704-e1e4f405366e',
APPLICATION_VERSION = '1.0.0',
APPLICATION_REGION = 'eu-north-1',
}